import React from 'react';
import Confetti from 'react-confetti';
import QRCode from 'react-qr-code';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Real ticket confirmation - tickets/movieTitle/showtime/auditorium come
// from the actual confirmCheckout response (see TheaterRoom.js), not
// fabricated client-side. The QR code encodes the real app deep link for
// that ticket's id, not a placeholder URL that points nowhere.
const Success = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { tickets, movieTitle, showtime, auditorium } = location.state || {};

  if (!tickets || tickets.length === 0) {
    return (
      <div style={styles.page}>
        <div style={styles.container}>
          <h1 style={styles.title}>{t('success.noTicketTitle')}</h1>
          <p style={styles.subtitle}>{t('success.noTicketSubtitle')}</p>
          <Link to="/Showtimes" style={styles.homeLink}>{t('success.browseShowtimes')}</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <Confetti recycle={false} numberOfPieces={250} />
      <div style={styles.container}>
        <h1 style={styles.title}>{t('success.congrats')}</h1>
        <p style={styles.subtitle}>{movieTitle} • {showtime} • {auditorium?.format === 'IMAX' ? 'IMAX' : 'Digital'} Auditorium {auditorium?.auditoriumNumber}</p>
        <div style={styles.linksContainer}>
          {tickets.map((ticket) => {
            const deepLink = `starviewcinema://ticket?ticketId=${ticket.ticket_id}`;
            return (
              <div key={ticket.ticket_id} style={styles.ticketCard}>
                <p style={styles.seatLabel}>Seat {ticket.seat_id}</p>
                <div style={styles.qrCode}>
                  <QRCode value={deepLink} size={140} />
                </div>
                <p style={styles.ticketId}>{t('success.ticket')} #{ticket.ticket_id}</p>
                <a href={deepLink} style={styles.appButton}>{t('success.openInApp')}</a>
              </div>
            );
          })}
        </div>
        <Link to="/" style={styles.homeLink}>Back to Home</Link>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#001f3f',
    position: 'relative',
    padding: '20px',
  },
  container: {
    backgroundColor: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(135,206,235,0.25)',
    padding: '30px',
    borderRadius: '16px',
    textAlign: 'center',
    width: 'min(90vw, 600px)',
  },
  title: {
    fontSize: '24px',
    color: '#fff',
    marginBottom: '8px',
    fontWeight: 900,
  },
  subtitle: {
    fontSize: '14px',
    color: '#87CEEB',
    marginBottom: '24px',
  },
  linksContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '16px',
  },
  ticketCard: {
    backgroundColor: 'rgba(255,255,255,0.05)',
    borderRadius: '12px',
    padding: '16px',
    width: '170px',
  },
  seatLabel: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '16px',
    marginBottom: '10px',
  },
  qrCode: {
    backgroundColor: '#fff',
    padding: '8px',
    borderRadius: '8px',
    display: 'inline-block',
  },
  ticketId: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: '12px',
    marginTop: '10px',
  },
  appButton: {
    display: 'inline-block',
    marginTop: '10px',
    background: '#87CEEB',
    color: '#001f3f',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '13px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  homeLink: {
    display: 'inline-block',
    marginTop: '24px',
    color: 'rgba(255,255,255,0.5)',
    fontSize: '13px',
  },
};

export default Success;
